import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import API from '../../utils/API';
import SourcedVenueOverview from '../../sections/sourced-venue/overview';
import SourcedVenueDetails from '../../sections/sourced-venue/details';
import EventDetails from '../../sections/sourced-venue/eventDetails';
import RoomBlocks from '../../sections/sourced-venue/roomBlocks';
import MeetingSpaces from '../../sections/sourced-venue/meetingSpaces';
import AdditionalInfo from '../../sections/sourced-venue/additionalInfo';
import Concessions from '../../sections/sourced-venue/concessions';
import PlannerInfo from '../../sections/sourced-venue/plannerInfo';
import AgencyInfo from '../../sections/sourced-venue/agencyInfo';
import RFPStatus from '../../sections/sourced-venue/rfpStatus';
import LoadingWizard from '../../components/spinner/wizard';

class SourcedVenue extends Component {
	constructor(props) {
		super(props);
		this.state = {
			venue: props.venue,
			loading: false
		};
	}

	getVenueData = async () => {
		const venueId = this.props.match.params.venue;
		await API().get(`Organizations/${this.props.orgId}/sourced-venues/${venueId}`).then((res) => {
			if (res.data) {
				this.setState({ venue: res.data, loading: false });
			}
		});
	};

	deleteVenue = async (venueId, callback) => {
		await API()
			.delete(`Organizations/${this.props.orgId}/sourced-venues/${venueId}`)
			.then((res) => {
				if (res.data) {
					callback(false);
					window.location.href = `/${this.props.orgId}/venues`;
				}
			})
			.catch((e) => {
				console.log(e);
				callback(true);
			});
	};

	render() {
		const { venue, loading } = this.state;
		const venueId = this.props.match.params.venue;
		const orgId = this.props.orgId;

		return (
			<div className="pageContainer">
				{!loading && (
					<Switch>
						<Route exact path="/:organization/venues/:venue">
							<SourcedVenueOverview
								venue={venue}
								orgId={orgId}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/info">
							<SourcedVenueDetails
								venue={venue}
								orgId={orgId}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/event-details">
							<EventDetails
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/room-blocks">
							<RoomBlocks
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/meeting-spaces">
							<MeetingSpaces
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/additional-info">
							<AdditionalInfo
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/concessions">
							<Concessions
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/planner-info">
							<PlannerInfo
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/agency-info">
							<AgencyInfo
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
						<Route path="/:organization/venues/:venue/rfp-status">
							<RFPStatus
								venue={venue}
								venueId={venueId}
								orgId={orgId}
								refreshSectionCounts={this.props.refreshSectionCounts}
							/>
						</Route>
					</Switch>
				)}
				<LoadingWizard loading={loading} text="Loading venue" />
			</div>
		);
	}
}

export default SourcedVenue;
